export const ROUTES = {
  root: '/',
  login: '/login',
  accessDenied: '/access-denied',
  partner: {
    root: '/partner',
    profile: '/partner/profile',
    application: '/partner/application',
    applicationMenu: '/partner/application/menu',
    applicationEdit: {
      link: (id: string) => `/partner/application/${id}`,
    },
    applicationSign: {
      link: (id: string) => `/partner/application/${id}/sign`,
    },
  },
  profile: '/profile',
  dashboard: '/dashboard',
  transactions: {
    root: '/transactions',
    loans: '/transactions/loans',
    payments: '/transactions/payments',
  },
  orders: {
    root: '/orders',
    create: '/orders/create',
  },
} as const;
